// src/components/blog/BlogPostCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { ArrowRight } from 'lucide-react';

function BlogPostCard({ post }) {
  return (
    <article className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
      {post.imageUrl && (
        <div className="h-48 overflow-hidden">
          <img 
            src={post.imageUrl} 
            alt={post.title} 
            className="w-full h-full object-cover transition-transform hover:scale-105 duration-300"
            loading="lazy"
          />
        </div>
      )}
      <div className="p-6">
        {post.category && (
          <span className="inline-block text-xs font-medium text-blue-600 uppercase tracking-wider mb-2">
            {post.category}
          </span>
        )}
        <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-2">
          <Link to={`/blog/${post.slug || post.id}`} className="hover:text-blue-600 transition-colors">
            {post.title}
          </Link>
        </h3>
        <div className="text-sm text-gray-600 mb-3">
          {post.publishDate && (
            <time dateTime={post.publishDate.toISOString()}>
              {format(post.publishDate, 'MMMM d, yyyy')}
            </time>
          )}
        </div>
        <p className="text-gray-700 mb-4 line-clamp-3">
          {post.excerpt || post.content?.substring(0, 120) + '...'}
        </p>
        <Link 
          to={`/blog/${post.slug || post.id}`} 
          className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium text-sm"
        >
          Read More <ArrowRight className="ml-1 h-4 w-4" />
        </Link>
      </div>
    </article>
  );
}

export default BlogPostCard;